import React from 'react';
export function BotanicalDivider({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex justify-center items-center w-full py-8 opacity-60 ${className}`} data-id="element-30">
      <svg width="120" height="30" viewBox="0 0 120 30" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-31">
        <path d="M10 15C30 15 40 5 60 5C80 5 90 15 110 15" stroke="#8BA888" strokeWidth="1.5" strokeLinecap="round" data-id="element-32" />
        <path d="M60 5C55 10 50 15 60 25C70 15 65 10 60 5Z" fill="#8BA888" fillOpacity="0.4" stroke="#8BA888" strokeWidth="1" data-id="element-33" />
        <path d="M35 10C32 13 29 16 35 22C41 16 38 13 35 10Z" fill="#8BA888" fillOpacity="0.3" stroke="#8BA888" strokeWidth="0.5" data-id="element-34" />
        <path d="M85 10C82 13 79 16 85 22C91 16 88 13 85 10Z" fill="#8BA888" fillOpacity="0.3" stroke="#8BA888" strokeWidth="0.5" data-id="element-35" />
      </svg>
    </div>;
}